"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBucketAnalyticsConfigurationsInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContinuationToken: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "continuation-token"
        }
    }
};
//# sourceMappingURL=ListBucketAnalyticsConfigurationsInput.js.map